import { createApp } from 'vue';
import Index from '@views/Index.vue';
import store from '@store/index';
import Swiper from 'swiper';
// import VueViewer from 'v-viewer';
import { getParam } from '@utils/index';
import '@scss/pc.scss';
// import 'swiper/swiper.scss';
import '@scss/swiper.scss';
// import 'viewerjs/dist/viewer.css';
import { stat } from '@lib/activity';
import { initReport } from '@lib/reserveDataReport';

const app = createApp(Index);
(app as any).config.globalProperties.$swiper = Swiper;
app.use(store);
// app.use(VueViewer);
app.mount('#app');

// 统计
dataLayer.push({
  event: 'entrance',
  scid: getParam('scid'),
  cid: getParam('cid'),
});

try {
  initReport();
  stat();
} catch (e) {
  console.error(e);
}
